import React from 'react';

export default function ConfirmModal({ open, title = 'Confirm', message = '', onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel', loading = false, danger = false }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <div className="flex flex-col gap-4">
          <div className="text-lg font-semibold">{title}</div>
          <div className="text-sm text-gray-700">{message}</div>
          <div className="flex justify-end gap-3 mt-4">
            <button onClick={onCancel} className="px-4 py-2 rounded-md border">{cancelLabel}</button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className={`px-4 py-2 rounded-md text-white ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-buttonRed hover:bg-buttonRed-hover'}`}
            >
              {loading ? 'Please wait…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
